var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { I18nService } from '@/services/i18n-service';
let CopyCustomFieldActionContribution = class CopyCustomFieldActionContribution {
    constructor(_i18nService) {
        this._i18nService = _i18nService;
    }
    registerCustomFieldActions(actions) {
        actions.registerCustomFieldAction({
            commandId: 'custom-field.copy',
            icon: 'SolidCopy',
            label: this._i18nService.t('customField.actions.copyTo'),
            order: 2,
            isEnabled: (context) => {
                if (context.isPublicMode) {
                    return context.isAdmin || context.fields[0].create_by_me;
                }
                return true;
            },
            isVisible: (context) => {
                if (context.isPublicMode) {
                    return context.isAdmin || context.fields[0].create_by_me;
                }
                return true;
            },
        });
    }
};
CopyCustomFieldActionContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object])
], CopyCustomFieldActionContribution);
export { CopyCustomFieldActionContribution };
